/**
 * VehicleList
 */
import Datepicker from "./Datepicker";
import Flickity from './../../Libraries/Flickity';

export default class VehicleList {

    // constructor
    constructor(selector) {
        this.$plugin = $(selector);
        let $plugin = this.$plugin;
        if ($plugin.length === 0) {
            return false;
        }

        let vm = this;
        this.$filter = $plugin.find('[data-tncp-vehiclelist="filter"]');
        this.$result = $plugin.find('[data-tncp-vehiclelist="results"]');
        this.loadFilterSettings();

        // advanced filter toggle
        $plugin.on('click', '[data-tncp-showsection-toggle]', function () {
            let $toggle = $(this);
            $plugin.find('[data-tncp-showsection-toggle]').show();
            $toggle.hide();
            $plugin.find('[data-tncp-showsection]').attr('data-tncp-showsection', $toggle.data('tncpShowsectionToggle'));
            return false;
        });

        // pagination trigger
        $plugin.on('click', '[data-tncp-pagination-page]', function () {
            let $el = $(this);
            let value = $el.attr('data-tncp-pagination-page');
            $plugin.find('[data-tncp-pagination-value]').val(value);
            vm.getResults().then(() => {
                $('html,body').animate({
                    scrollTop: $('[data-scrollto-target]').offset().top
                });
            });
        });
    }

    // load filter settings
    loadFilterSettings() {
        let vm = this;
        vm.request = window.xhrRequest({
            url: vm.$plugin.find('[data-tncp-vehiclelist-filtersettings-xhr]').attr('data-tncp-vehiclelist-filtersettings-xhr'),
            method: 'GET',
        });
        vm.request.then((response) => {
            vm.$filter.html(response.data.content);
            vm.$plugin.find('[data-powerview-options]').hide();

            new Datepicker(vm.$plugin.selector);

            vm.setFilter();
            vm.execute();

            vm.$filter.find('input:not([type])').on('keypress', function (e) {
                if (e.key === 'Enter') {
                    event.preventDefault();
                    vm.$filter.find('[data-tncp-vehiclelist="filterForm"]').submit();
                }
            });
        });
    }

    // set filter
    setFilter() {
        let vm = this;
        let serializedString = window.tncpRouter.getRoute();
        serializedString = serializedString.split('/')[1];

        if(serializedString) {
            serializedString = atob(serializedString);

            let $form = vm.$plugin.find('[data-tncp-vehiclelist="filterForm"]');
            $form[0].reset();
            serializedString = serializedString.replace(/\+/g, '%20');
            let formFieldArray = serializedString.split("&");

            if (serializedString !== '') {
                $.each(formFieldArray, function (i, pair) {

                    let nameValue = pair.split("=");
                    let name = decodeURIComponent(nameValue[0]);
                    let value = decodeURIComponent(nameValue[1]);
                    // Find one or more fields
                    let $field = $form.find('[name="' + name + '"]');
                    if ($field.length) {
                        if (typeof $field[0].type !== 'undefined' && $field[0].type === "radio" || $field[0].type === "checkbox") {
                            let $fieldWithValue = $field.filter('[value="' + value + '"]');
                            let isFound = ($fieldWithValue.length > 0);
                            if (!isFound && value === "on") {
                                $field.first().prop("checked", true);
                            } else {
                                $fieldWithValue.prop("checked", isFound);
                            }
                        } else {
                            $field.val(value);
                        }
                    }
                });
            }
        }
    }

    // execute
    execute() {
        let vm = this;
        // on page load
        vm.getResults();

        // on form submit
        vm.$plugin.on('submit', '[data-tncp-vehiclelist="filterForm"]', () => {
            vm.$plugin.find('[data-tncp-pagination-value]').val(''); // resets the pagination on filter change
            vm.getResults();
            return false;
        });

    }

    // get results
    getResults() {
        let vm = this;
        return new Promise(function(resolve, reject) {
            let $form = vm.$plugin.find('[data-tncp-vehiclelist="filterForm"]');

            if ($form.length > 0) {
                vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'true');
                let serializedFilters = $form.serialize();
                vm.disableForm($form);

                let route = window.tncpRouter.getRoute();
                let currentTab = route.split('/')[0];

                $('[data-tncp-filter-serialized]').each(function(index) {
                    if ($(this).attr('data-tncp-tab') === currentTab) {
                        $(this).val(currentTab + '/' + btoa(serializedFilters));
                    }
                });

                $('#csv-filter-input' + currentTab).val(btoa(serializedFilters));

                vm.request = window.xhrRequest({
                    url: $form.attr('action'),
                    method: 'POST',
                    data: serializedFilters
                });
                vm.request.then((response) => {
                    vm.$result.html(response.data.content);
                    vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'false');
                    vm.disableForm($form, false);
                    if (response.data.resultsFound > 0) {
                        vm.$plugin.find('[data-powerview-options]').show();
                        const flickity = new Flickity;
                        flickity.processBar();
                    } else {
                        vm.$plugin.find('[data-powerview-options]').hide();
                    }

                    resolve(response);
                }).catch((e) => {
                    reject(e);
                });
            } else {
                vm.$plugin.find('[data-form--watch]').html('');
            }

        });
    }


    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }
}
